import React, { useEffect, useRef, useState } from "react";
import CodeEditor from "@uiw/react-textarea-code-editor";
import { Spin, Select, Modal, Button } from "antd";
import parse from "html-react-parser";
import { useHistory } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import rehypePrism from 'rehype-prism-plus';
import "../styles/problem.css";

const { Option } = Select;

export default function Problem({ match }) {
  const history = useHistory();
  const [language, setLanguage] = useState("cpp");
  const [loading, setLoading] = useState(false);
  const textareaRef = useRef();
  const [code, setCode] = useState(`#include <iostream>
#include <algorithm>
#define FOR(i,a,b) for(int i=a; i<b; i++)
#define ROF(i,a,b) for(int i=b; i>a; i--)
#define SORT(a,n) sort(a, a+n)
#define SORTR(a,n) sort(a, a+n, greater<int>())

using namespace std;
void solve(int tc)
{
    cout << "Case #" << tc << ": ";
    //Code here
}
int main()
{
    int T;
    cin >> T;
    FOR(i, 1, T+1) {
        solve(i);
    }
    return 0;
}`);

  const [problems, setProblems] = useState(null);

  const showSuccessModal = (message) => {
    Modal.success({
      title: "Code submitted and processed successfully",
      content: (
        <>
          {message.split("\n").map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </>
      ),
    });
  };

  const showErrorModal = (message, statusCode) => {
    Modal.error({
      title: `Error ${statusCode}`,
      content: message,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/problem/${match.params.id}`,
          {
            headers: new Headers({
              "x-access-token": localStorage.getItem("token"),
            }),
          }
        ).then((res) => res.json());
        setProblems(response);


      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
  }, [match.params.id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const content = textareaRef.current.value;

      if (!content.trim()) {
        alert("Code content cannot be empty.");
        return;
      }

      let mimeType = "text/plain";
      if (language === "cpp") {
        mimeType = "text/x-c++src";
      } else if (language === "c") {
        mimeType = "text/x-c";
      } else if (language === "python") {
        mimeType = "text/x-python";
      }

      // Create the Blob for the code file
      const fileBlob = new Blob([content], { type: mimeType });

      // Prepare form data for the initial upload
      const formData = new FormData();
      formData.append("code", fileBlob, `submission.${language}`);
      formData.append("problem_id", problems._id);
      formData.append("problem_name", problems.problem_name);
      formData.append("user_id", localStorage.getItem("user_id"));

      // Reset the form value
      e.target.reset();

      // Upload the file to the API
      const uploadResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/api/grader/uploadCode`,
        {
          method: "POST",
          body: formData,
          headers: {
            "x-access-token": localStorage.getItem("token"),
          },
        }
      );

      if (!uploadResponse.ok) {
        throw new Error("Failed to upload code to the server.");
      }

      // Process the code for multiple test cases
      const resultArr = [];
      const scoreArr = [];
      for (let i = 1; i <= 5; i++) {
        formData.set("i", i); // Update the index for test case processing
        const processResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/grader/processCode`,
          {
            method: "POST",
            body: formData,
            headers: {
              "x-access-token": localStorage.getItem("token"),
            },
          }
        );

        const processResult = await processResponse.json();
        resultArr.push(processResult.result);
        scoreArr.push(processResult.score);
      }

      // Prepare final result data for submission
      const resultData = new FormData();
      for (let i = 0; i < 5; i++) {
        resultData.append(`s${i + 1}`, resultArr[i]);
        resultData.append(`p${i + 1}`, scoreArr[i]);
      }
      resultData.append("problem_id", problems._id);
      resultData.append("problem_name", problems.problem_name);
      resultData.append("user_id", localStorage.getItem("user_id"));


      // Submit the final results
      const finalResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/api/grader/${problems._id}/${formData.get(
          "user_id"
        )}`,
        {
          method: "PUT",
          headers: {
            "x-access-token": localStorage.getItem("token"),
          },
          body: resultData,
        }
      );

      if (!finalResponse.ok) {
        throw new Error("Failed to submit final results.");
      }

      showSuccessModal(`Result is ${resultArr[0]}${resultArr[1]}${resultArr[2]}${resultArr[3]}${resultArr[4]}\
        \nTotal is ${scoreArr[0] + scoreArr[1] + scoreArr[2] + scoreArr[3] + scoreArr[4]}`);
    } catch (error) {
      console.error("Error:", error.message);
      showErrorModal(error.message, 500);

    }
    setLoading(false);
  };


  const handleLanguageChange = (value) => {
    console.log(problems);

    setLanguage(value);
    if (value === 'c') {
      setCode(`#include <stdio.h>
#define FOR(i,a,b) for(int i=a; i<b; i++)
void solve(int tc)
{
    printf("Case #%d: ", tc);
    //Code here
}
int main()
{
    int T;
    scanf("%d", &T);
    FOR(i, 1, T+1) {
        solve(i);
    }
    return 0;
}`);
    } else {
      setCode(`#include <iostream>
#include <algorithm>
#define FOR(i,a,b) for(int i=a; i<b; i++)
#define ROF(i,a,b) for(int i=b; i>a; i--)
#define SORT(a,n) sort(a, a+n)
#define SORTR(a,n) sort(a, a+n, greater<int>())

using namespace std;
void solve(int tc)
{
    cout << "Case #" << tc << ": ";
    //Code here
}
int main()
{
    int T;
    cin >> T;
    FOR(i, 1, T+1) {
        solve(i);
    }
    return 0;
}`);
    }
  };

  if (!problems) {
    return (
      <center>
        <Spin />
      </center>
    );
  }

  return (
    <div className="problem-container">
      <div className="header-problem">
        <FaArrowLeft
          className="back-icon"
          size={22}
          onClick={() => history.replace("/grader")}
        />
        <span className="problem-title">Problem - {problems.problem_name}</span>
      </div>

      <div className="problem-content">
        <div className="problem-statement">
          <section>{parse(problems.html_problem)}</section>
          <table className="table-io table-condensed">
            <tbody>{parse(problems.html_sample)}</tbody>
          </table>
        </div>
        <div className="code-editor-section">
          <CodeEditor
            ref={textareaRef}
            value={code}
            language={language}
            onChange={(evn) => setCode(evn.target.value)}
            data-color-mode="dark"
            padding={15}

            rehypePlugins={[[rehypePrism, { ignoreMissing: true }]]}
            style={{
              fontSize: 14,
              backgroundColor: "#001f3f",
              color: "#ffffff",
              fontFamily: 'Monaco, Consolas, "Lucida Console", monospace',
              height: "60vh",
              overflowY: "scroll",
              borderRadius: "8px", // Add rounded corners
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.5)", // Subtle shadow for styling

            }}
          />

          <br />
          <Select
            defaultValue="cpp"
            style={{ width: "30%" }}
            onChange={handleLanguageChange}
          >
            <Option value="c">C</Option>
            <Option value="cpp">C++17 (G++)</Option>

          </Select>
          <div style={{ float: "right" }}>
            <form onSubmit={handleSubmit}>
              <Button htmlType="submit" type="primary" loading={loading} >
                Submit Attempt
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}